import { render, staticRenderFns } from "./create_activity_pointExchange.vue?vue&type=template&id=5b81b319&scoped=true"
import script from "./create_activity_pointExchange.vue?vue&type=script&lang=js"
export * from "./create_activity_pointExchange.vue?vue&type=script&lang=js"
import style0 from "./create_activity_pointExchange.vue?vue&type=style&index=0&id=5b81b319&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b81b319",
  null
  
)

export default component.exports